import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';
import { flexCenter } from '../../../styles/mixins';

export const usePackageListPackagesStyles = createStyles(({ token }) => ({
  addOrCopyPackageButtons: {
    display: 'flex',
    alignItems: 'center',

    '.IconButton': {
      color: token.colorPrimary,
      marginRight: ThemeSpaces.SPACE_NORM0_5,

      '&:first-child': {
        fontSize: 21,
      },
      '&:nth-child(2)': {
        fontSize: ThemeFont.FONT_SIZE_20,
      },
    },

    '.text': {
      marginLeft: ThemeSpaces.SPACE_NORM0_5,
      fontSize: token.fontSizeLG,
      lineHeight: 1,
      fontWeight: 500,
      color: ThemeColors.COLOR_GREY_BLUISH2,
    },
  },
  newShipmentPackagesListSlider: {
    '.NewShipmentPackagesSummary + &': {
      marginTop: -ThemeSpaces.SPACE_NORM,
    },

    marginBottom: 0,
    '.SlidingContent-ContentTab > *:last-child': {
      marginBottom: ThemeSpaces.SPACE_NORM_20,
    },
  },
  newShipmentPackagesListSliderHeader: {
    marginBottom: ThemeSpaces.SPACE_NORM,

    '.IconButton': {
      display: 'flex',
      fontSize: 19,
      color: token.colorPrimary,
    },
  },
  newShipmentPackagesListSliderLabel: {
    fontSize: token.fontSizeLG,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    color: ThemeColors.COLOR_GREY3,
  },
  newShipmentPackagesListSliderButton: {
    ...flexCenter(),
    width: 20,
    height: 20,
    fontSize: token.fontSize,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    color: ThemeColors.COLOR_GREY3,
    borderRadius: token.borderRadius,
    cursor: 'pointer',

    '&.active': {
      backgroundColor: token.colorWhite,
      color: token.colorPrimary,
      border: `1px solid ${token.colorPrimary}`,
      boxShadow:
        '4px 4px 5px rgba(0, 0, 0, 0.14), 1px 1px 10px rgba(0, 0, 0, 0.12)',
    },
  },
}));
